import {
  captureException
  ,captureMessage
}  from '@sentry/browser'

/*
mode
0 disabled
1 error
2 message
*/
export function error (exception) {
  let mode=Number(process.env.SENTRY_MODE) || 0
  if(mode >=1 ){
    console.log("sentry log exception")
    captureException(exception)
  } 
}

export function info(message) {
  let mode=Number(process.env.SENTRY_MODE) || 0
  if(mode >=2 ){
    console.log("sentry log message")
    captureMessage(message)
  }
}

export function forceError(message) {
  console.log("sentry log error")
  captureMessage(message)  
}

